module.exports = __webpack_public_path__ + "img/logo_color.e3a614be.svg";